import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"margin-top":"-50px","position":"relative"}
}
const _hoisted_2 = { class: "highlight-overlay-rounded-container pt-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col col-4 offset-1 d-none d-lg-block" }
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "col col-12 col-lg-6 ps-5 pe-5" }
const _hoisted_8 = { class: "display-4" }
const _hoisted_9 = { class: "pitch-font" }
const _hoisted_10 = { class: "col col-12 d-lg-none d-block" }
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require(`@/assets/${$props.imageSrc}`),
              class: "",
              height: "200",
              width: "",
              alt: $data.imgAltText
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString($props.title), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString($props.text), 1),
          _createVNode(_component_router_link, {
            to: "/request-a-demo",
            class: "btn btn-lg my-4",
            style: {"background":"var(--background-color-attention-emphasis) 0% 0% no-repeat padding-box","color":"black"}
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createTextVNode("Request a Demo ", -1)),
              _createVNode(_component_font_awesome_icon, {
                icon: "fa fa-arrow-right",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col col-1" }, null, -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: require(`@/assets/${$props.imageSrc}`),
              class: "",
              height: "200",
              width: "",
              alt: $data.imgAltText
            }, null, 8, _hoisted_12)
          ])
        ])
      ])
    ])
  ]))
}